import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSeller() {
    let response = await wsGetAll('sale/seller-quote-winter/sellers-bureau');
    if (response.success) setSellers(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model); // actualiza data
      listSeller(); // <- ahora siempre se lista al abrir
    }
  }, [props.model]);


  return (
    <>
      <Modal
        title={`Cambiar el vendedor`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/seller-quote-winter/change-seller'
        dataForce={{
          SlpCodeOld: props.model.SlpCode,
          SlpCodeNew: dataChanging.SlpCode,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={sellers}
          getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
          renderInput={(params) => (
            <TextField {...params} label="Vendedor" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('SlpCode', item?.SlpCode);}}
          value={sellers.find((seller) => seller.SlpCode === dataChanging.SlpCode) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
      </Modal>
    </>
  );
}
